import a from "./index944.js";
import o from "./index820.js";
var e = a(o, "WeakMap");
export {
  e as default
};
